<template>
    <section class="club-management main-body">
        <div class="clubs">
            <MiniHeader
                :heading="`Clubs User`"
                :buttonText="'Add Club User'"
                :hasButton="true"
                @buttonClicked="createClub()"
            >
                <router-link></router-link>
            </MiniHeader>
            <div class="search-users">
                <div class="search-users__section search-users__section--select">
                    <label
                        for="field"
                        class="search-users__label"
                    >Field to search</label>
                    <v-select
                        id="field"
                        item-text='name'
                        item-value='value'
                        :items="searchOptions"
                        v-model="searchFieldParameter"
                        solo
                        flat
                    ></v-select>
                </div>
    
                <div class="search-users__section search-users__section--text-field">
                    <label
                        for="search-text"
                        class="search-users__label"
                    >Starts with:</label>
                    <v-text-field
                        id="search-text"
                        placeholder=""
                        solo
                        flat
                        v-model="searchText"
                        @keyup.enter="getAllClubUsers"
                    ></v-text-field>
                </div>
                <div class="search-users__section">
                    <v-btn
                        :disabled="searchText === '' || searching"
                        accent
                        type="button"
                        @click="getAllClubUsers()"
                    >
                        Search Users
                    </v-btn>
                </div>
            </div>
            <div v-if="allClubUsers.length > 0">
                <club-user-listing
                :clubUsers="clubUsers"
            />
            </div>
            <div v-else>
                <div>No users to display</div>
            </div>
        </div>

        <div class="pagination">
            <v-pagination
                v-if="pageCount"
                v-model="pageNumber"
                :length="pageCount"
                :total-visible="7"
                circle
                color="accent"
            />
        </div>
        <router-view></router-view>
    </section>
</template>

<script>
import axios from "axios"
import MiniHeader from "../../components/Library/MiniHeader.vue"
import  ClubUserListing from "./ClubUserListing.vue"
export default {
    name: "ClubUserManagement",

    components: {
        MiniHeader,
        ClubUserListing,
    },
    data: () => ({
        api: `${process.env.VUE_APP_CLUBSAPI}`,
        allClubUsers: [],
        clubUsers: [],
        pageNumber: 1,
        pageSize: 10,
        pageCount: null,
        searchFieldParameter: "email",
        searchText: "",
        searching: false,
        searchOptions: [
            { name: "Email", value: "email" },
            { name: "Given Name", value: "given_name" },
            { name: "Family Name", value: "family_name" },
        ]
    }),
    
    mounted() {
        this.getAllClubUsers(),
        this.filterClubUsers()
    },
    watch: {
        pageNumber() {
            this.getAllClubUsers()
            this.filterClubUsers();
        },
        searchText() {
            this.pageNumber = 1;
            this.filterClubUsers();
        },
        searchFieldParameter() {
            this.pageNumber = 1;
            this.filterClubUsers();
        }
    },

    methods: {
        paginate(array) {
            const start = (this.pageNumber - 1) * this.pageSize;
            return array.slice(start, start + this.pageSize);
        },
        getAllClubUsers() {
            this.$store.commit("startLoading");
            this.$getCurrentUserJwToken().subscribe((jwt) => {

                const url = `${this.api}/users?page.number=${this.pageNumber}&page.size=${this.pageSize}`; 

                axios({
                    method: "GET",
                    url: url,
                    headers: { "Authorization": jwt }
                })
                .then(response => {
                    this.allClubUsers = response.data.data
                    this.pageCount = response.data.meta.totalPages
                    this.filterClubUsers(); 
                })
                .catch(e => {
                    console.log("Unable to load teams:", e);
                    this.$store.commit("completeLoading");
                })
                this.$store.commit("completeLoading");
            })        
        },
        filterClubUsers() {
            if (!this.searchText) {
                this.clubUsers = this.allClubUsers;
            } else {
                const filtered = this.allClubUsers.filter(user => {
                    const value = (user.attributes && user.attributes[this.searchFieldParameter]) ||  "";
                    return value.toLowerCase().startsWith(this.searchText.toLowerCase());
                });
                this.pageCount = Math.ceil(filtered.length / this.pageSize);
                this.clubUsers = this.paginate(filtered);
            }
        },
        createClub () {   
            this.$router.push({
                name: "Create Club User",
                path: "/clubuser/create"
            })
        }
    }
}
</script>
<style lang=scss>
.search-users {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 16px;
    padding: 16px 8px;
    background-color: #fff;
    border: 1px solid #ccc;

    &__section {
        padding: 0 8px;

        &--select {
            width: 170px;
        }

        &--text-field {
            width: 50%;
        }
    }

    &__label {
        display: block;
        margin: 0 0 4px;
    }
}

.create-buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    &__add-entitlement {
        margin-left: 16px;
    }
}

.search-users-toggle {
    padding: 4px 8px;
    margin: 0 8px 0 0;
    opacity: 0.6;

    &.is-active {
        color: #fff;
        background: #67247c;
        opacity: 1;
    }
}
</style>